import { render, staticRenderFns } from "./ReturnMerchBill.vue?vue&type=template&id=252f18c4&scoped=true"
import script from "./ReturnMerchBill.vue?vue&type=script&lang=ts"
export * from "./ReturnMerchBill.vue?vue&type=script&lang=ts"
import style0 from "./ReturnMerchBill.vue?vue&type=style&index=0&id=252f18c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f18c4",
  null
  
)

export default component.exports